<script setup>
import Commons from '@/app/features/shared/libraries/commons';
</script>

<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.AFFILIATION.REQUEST_LINK_SHARING"
    :handler="() => $refs.modal.show()"
  />

  <DialogComponent
    ref="modal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
    mainClass="[&_.bottomsheetBox]:bg-slate-50!"
  >
    <div class="w-full h-full flex flex-col overflow-auto p-4 gap-2">
      <div class="mobile-status-padding"></div>

      <div class="title-color text-2xl font-bold text-center">
        Partager lien d'affiliation
      </div>

      <div class="py-2"></div>
      <div class="px-10 md:px-10 pb-10 md:pt-12 gap-6">
        <div class="flex justify-between">
          <div
            class="flex flex-col items-center gap-4 justify-center"
            v-for="(sharing, i) in $constants.AFFILIATION.SHARINGS"
            :key="i"
            :data-sharer="sharing.type"
            :data-title="`Hello, Inscris toi sur 1BPay et fais tes recharges et retrait instantané`"
            :data-url="'https://1bpay.me'"
          >
            <div
              class="ripple rounded-full w-16 h-16 flex items-center justify-center p-5"
              :class="[sharing.class]"
            >
              <ImgComponent :src="sharing.logo" alt="" class="w-full h-full" />
            </div>
            <div class="text-sm title-color font-semibold">
              {{ sharing.name }}
            </div>
          </div>
        </div>
        <!-- <div class="py-8"></div> -->
        <div class="" v-if="false">
          <button
            @click="
              Commons.copyToClipboard(
                'https://1bpay.me',
                () => {
                  $bus.emit($constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
                    title: 'Lien copié',
                    body: 'https://1bpay.me'
                  });
                },
                () => {
                  $bus.emit($constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
                    title: 'Lien non copié',
                    body: 'Veuillez réessayer'
                  });
                }
              )
            "
            class="relative ripple rounded-xl !bg-transparent small shadow-none !py-3 !px-2 !title-color border-primary border border-dashed hover:!saturate-100 w-full"
          >
            <div
              class="absolute -top-[8px] left-[4px] opacity-100 text-sm bg-white pr-2"
            >
              <span class="opacity-80"> Ou Copier le lien </span>
            </div>
            <div
              class="w-full flex justify-between text-left items-center gap-2"
            >
              <div class="w-full truncate overflow-hidden">
                <span class="w-full">
                  {{ 'https://1bpay.me' || '-' }}
                </span>
              </div>
              <div class="w-6 h-6 min-w-6">
                <ColorImg
                  src="/images/all/copy.svg"
                  alt=""
                  class="w-full h-full bg-primary"
                />
              </div>
            </div>
          </button>
        </div>
        <div class="py-4"></div>
      </div>
    </div>
  </DialogComponent>
</template>
